'use strict';

bbw.directive.bbwBanner = ['rpcClient', 'bbw.RetinaDetectorSvc', '$sce', function(rpcClient, retinaDetector, $sce) {

    return {
        templateUrl: bbw.templateUrl('banner.html'),
        transclude: true,
        scope: {
            slot: '@bbwBanner'
        },
        link: function(scope, element) {
            if (!scope.slot) {
                element.css('display', 'none');
                return;
            }
            var buildSizeCss = function(banner) {
                return [banner.width, banner.height].map(function(value) {
                    return '' + value + 'px';
                }).join(' ');
            };
            var setBanner = function(banner) {
                var isRetina = retinaDetector.isRetina();
                banner.selectedImage = 'url(' + (isRetina ? banner.image_url_x2 : banner.image_url) + ')';
                banner.selectedSize = buildSizeCss(banner);
                banner.link = $sce.trustAsResourceUrl(banner.href);
                scope.banner = banner;
                element.css('display', 'block');
            };
            rpcClient.get('bnr/slot/' + scope.slot).execute().then(function(response) {
                if (!response.banner) {
                    element.css('display', 'none');
                    return;
                }
                setBanner(response.banner);
            });
        }
    }

}];
